import {Basic, Ventrata} from 'types'
import {getUnitPricing} from 'utils/getPricingFrom'

export const getProductPricingFrom = (product: Ventrata.Product, currency: Basic.Currency) => {
  const unitPricingMap: Partial<Record<string, number>> = {}

  for (const option of product.options) {
    for (const unit of option.units) {
      const savedUnitPricingFrom = unitPricingMap[unit.id]

      const unitPricingFrom = getUnitPricing(unit, currency, 'pricingFrom')?.retail || 0

      if (!savedUnitPricingFrom || unitPricingFrom < savedUnitPricingFrom) {
        unitPricingMap[unit.id] = unitPricingFrom
      }
    }
  }

  return unitPricingMap
}
